<script>
import { Line } from 'vue-chartjs'

// const brandPrimary = '#20a8d8'
// const brandSuccess = '#4dbd74'
// const brandInfo = '#63c2de'
// const brandDanger = '#f86c6b'
const brandInfo = '#4dbd74'
const brandSuccess = '#f86c6b'

function convertHex (hex, opacity) {
  hex = hex.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  const result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
  return result
}

// function random (min, max) {  return Math.floor(Math.random() * (max - min + 1) + min) }

let datasets = [
  {
    label: 'Areceber',
    backgroundColor: convertHex(brandInfo, 10),
    borderColor: brandInfo,
    pointHoverBackgroundColor: '#fff',
    borderWidth: 2,
    data: []
  },
  {
    label: 'Apagar',
    backgroundColor: 'transparent',
    borderColor: brandSuccess,
    pointHoverBackgroundColor: '#fff',
    borderWidth: 2,
    data: []
  }
]
export default {
  extends: Line,
  props: ['height'],
  methods: {
    getDadosAreceber () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/areceber/listarproximos20dias')
      let promise = this.$http.get(uri)
      return promise
        .then((data) => {
          if (data) {
            datasets[0].data = []
            let i
            let titulos = []
            for (i = 0; i < data.data.length; i++) {
              datasets[0].data.push(data.data[i].VALOR)
              titulos.push(data.data[i].DIA)
            }
            return titulos
          }
        })
    },
    getDadosApagar () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/apagar/listarproximos20dias')
      let promise = this.$http.get(uri)
      return promise
        .then((data) => {
          if (data) {
            datasets[1].data = []
            let i
            let titulos = []
            for (i = 0; i < data.data.length; i++) {
              datasets[1].data.push(data.data[i].VALOR)
              titulos.push(data.data[i].DIA)
            }
            return titulos
          }
        })
    }
  },
  created () {
    this.getDadosAreceber()
      .then((data) => {
        this.getDadosApagar()
          .then((data) => {
            this.renderChart({
              labels: data,
              datasets: datasets
            }, {
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                xAxes: [{
                  gridLines: {
                    drawOnChartArea: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    maxTicksLimit: 5
                    // stepSize: Math.ceil(250 / 5)
                    // max: 250
                  },
                  gridLines: {
                    display: true
                  }
                }]
              },
              elements: {
                point: {
                  radius: 0,
                  hitRadius: 10,
                  hoverRadius: 4,
                  hoverBorderWidth: 3
                }
              }
            })
          })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/MainChartExample.vue